import React from "react";

import { stylize } from "@envestnet/envreact-component-library";
import withIntl from "utils/withIntl";

import AppVerifyStepOne from "components/AppVerifyStepOne";
import AppVerifyStepThree from "components/AppVerifyStepThree";
import AppVerifyStepTwo from "components/AppVerifyStepTwo";
import AuthenticatorHeader from "components/AuthenticatorHeader";
import Logo from "images/EnvLogo";

import { mfaFlow } from "utils/enum";
import { AppTypeEnum } from "./enums";

import styles from "./styles";
import { StatusType, SubmissionStateType } from "./types";

type DefaultProps = {
  // Default props should always be required props, i.e. no ? indicating it's optional
  // The default values are specified below

  /** Description of this prop */

  loadQRCode: Function;
  submitPassCode: Function;
  loadStatus: Function;
  resetSubmissionStatus: Function;
  loadingPassCodeSubmission: SubmissionStateType;
  qrCodeLink: string;
  status: StatusType;
  secretCode: string;
  username: string;
  currentLayout: mfaFlow;
};

interface AppAuthProps {
  hideLogo: boolean;
  activeStep: number;
  redirectToMfa: Function;
  setActiveStep: Function;
  authenticatorName: string;
}

type Props = AppAuthProps & DefaultProps;
const AppAuth = (props: Props) => {
  const {
    hideLogo,

    redirectToMfa,
    loadQRCode,
    qrCodeLink,
    submitPassCode,
    loadingPassCodeSubmission,
    loadStatus,
    status,
    setActiveStep,
    secretCode,
    resetSubmissionStatus,
    username,
    activeStep,
    authenticatorName,
    currentLayout,
  } = props;
  return (
    <>
      {!hideLogo && <Logo />}
      <AuthenticatorHeader
        authenticatorName={authenticatorName}
        userId={username}
      />
      {activeStep === 1 && (
        <AppVerifyStepOne
          onNext={() => loadStatus({ authenticatorType: AppTypeEnum.APP })}
          onCancel={redirectToMfa}
          loadQRCode={loadQRCode}
          currentLayout={currentLayout}
          qrCodeLink={qrCodeLink}
          status={status}
          onCantScan={() => {
            setActiveStep(3);
          }}
        />
      )}
      {activeStep === 2 && (
        <AppVerifyStepTwo
          onCancel={redirectToMfa}
          onBack={() => setActiveStep(1)}
          onSubmitPassCode={submitPassCode}
          processingStatus={loadingPassCodeSubmission}
          resetSubmissionStatus={resetSubmissionStatus}
        />
      )}
      {activeStep === 3 && (
        <AppVerifyStepThree
          onNext={() => loadStatus({ authenticatorType: AppTypeEnum.APP })}
          status={status}
          secretCode={secretCode}
          onCancel={redirectToMfa}
        />
      )}
    </>
  );
};

export default withIntl(stylize<Props, DefaultProps>(styles)(AppAuth));
